<template>
  <div>
  <!-- {{ mode }} -->
    <div v-if="mode == 2" class="td-x-20 pd-y-15 text-center">
      <!--  -->
      <button
      v-if="prms.resultCount < prms.attemptCount"
        v-on:click="$emit('refillLessonExam')"
        class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
      >
        Дахин оролдох
      </button>
    </div>
    <div v-else-if="mode == 3" class="td-x-20 pd-y-15 text-center">
      <button
        @click="$emit('showLessonExamResult')"
        class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
      >
        Үр дүнгүүд
      </button>
      <ul class="list-group list-group-flush tx-13">
        <li class="list-group-item d-flex pd-sm-x-20">
          <div class="avatar d-none d-sm-block">
            <span class="avatar-initial rounded-circle bg-success">
              <i class="icon ion-md-checkmark"></i>
            </span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-0">Зөв хариулсан</p>
          </div>
        </li>

        <li class="list-group-item d-flex pd-sm-x-20">
          <div class="avatar d-none d-sm-block">
            <span class="avatar-initial rounded-circle bg-danger">
              <i class="icon ion-md-checkmark"></i>
            </span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-0">Буруу хариулсан</p>
          </div>
        </li>
        <li class="list-group-item d-flex pd-sm-x-20">
          <div class="avatar d-none d-sm-block">
            <span class="avatar-initial rounded-circle bg-warning">
              <i class="icon ion-md-close"></i>
            </span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-0">Бөглөөгүй</p>
          </div>
        </li>
      </ul>
    </div>
    <div v-else-if="mode == 4">
      <div v-for="(s, i) in form.sections" :key="i">
        <label
          class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-10"
          >{{ romanize(i + 1) }}. {{ s.name }}</label
        >
        <div class="pd-x-20">
          <div class="row">
            <div
              :class="`align-items-center mg-b-5`"
              v-for="(q, qi) in form.questions.filter(x => x.sId == s.id)"
              :key="qi"
            >
              <button
                type="button"
                :class="
                  `btn mg-l-3 ${q.isFilled ? 'btn-primary' : ''} rounded-pill`
                "
              >
                {{ qi + 1 >= 10 ? qi + 1 : "0" + (qi + 1) }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="td-x-20 pd-y-15 text-center">
        <button
          @click="$emit('finishLessonExam', form.resultId)"
          class="btn btn-sm pd-x-15 btn-warning btn-uppercase"
        >
          Дуусгах
        </button>
      </div>
    </div>
    <div v-else-if="mode == 0">
      <!-- <div>
    <div style="height: 300px; width: 300px; overflow: auto">
      <div ref="scrollContainer">
        <div id="section1" style="height: 500px; border: 1px solid #ccc;">
          Section 1
        </div>
        <div id="section2" style="height: 500px; border: 1px solid #ccc;">
          Section 2
        </div>
      </div>
    </div>

    <button @click="scrollToSection('section2')">Scroll to Section 2</button>
  </div> -->

      <div v-for="(s, i) in form.sections" :key="i">
        <label
          class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03"
          >{{ romanize(i + 1) }}. {{ s.name }}</label
        >
        <div></div>
        <button @click="$emit('go-to-q', q.id)"
          type="button"
          class="btn mg-l-3 rounded-pill"
          :class="{ 'btn-primary': q.isFilled }"
          v-for="(q, qi) in form.questions.filter(x => x.sn.id == s.id)"
          :key="qi"
        >
          {{ qi + 1 }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { romanize, alphabetize } from "@/libs/tools";

export default {
  components:{
    vueCustomScrollbar
  },
  props: {
    mode: {
      type: Number,
      default: () => 0
    },
    form: {
      type: Object,
      default: () => {}
    },
    prms: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    scrollToSection(sectionId) {
      const container = this.$refs.scrollContainer;
      const section = document.getElementById(sectionId);

      if (container && section) {
        // container.scrollTop = section.offsetTop;
        console.log('section.offsetTop', section.offsetTop);
        this.$nextTick(() => {
          container.scrollTo(0, section.offsetTop, 500);
        });
        
      }
    },
    romanize(v) {
      return romanize(v);
    },
    alphabetize(v) {
      return alphabetize(v);
    }
  }
};
</script>

<style></style>
